// extracted by mini-css-extract-plugin
export var avatarContainer = "_cd-0";
export var avatarTypingWave = "_cd-i";
export var gray = "_cd-f";
export var green = "_cd-c";
export var icon = "_cd-9";
export var image = "_cd-1";
export var lg = "_cd-6";
export var md = "_cd-5";
export var presenceDot = "_cd-b";
export var red = "_cd-d";
export var sm = "_cd-4";
export var status = "_cd-a";
export var typingDot = "_cd-h";
export var typingPill = "_cd-g";
export var xl = "_cd-7";
export var xs = "_cd-3";
export var xxl = "_cd-8";
export var xxs = "_cd-2";
export var yellow = "_cd-e";